import { processDefaultNode } from './buildDefaultNodeProcessor';
export var buildButtonTag = function () { return ({
    replaceChildren: false,
    shouldProcessNode: function (node) {
        return node.name === 'button';
    },
    processNode: function (node, children, index) {
        var props = node.attribs;
        // moving class -> className
        props.className = node.attribs['class'];
        delete props.class;
        node.attribs = props;
        return processDefaultNode(node, children, index);
        // React.createElement(node.name, props, children);
    },
}); };
//# sourceMappingURL=buildButtonTag.js.map